import React, { lazy } from 'react';
import { useParams } from 'react-router-dom';

import 'ag-grid-community/dist/styles/ag-grid.css';
import 'ag-grid-community/dist/styles/ag-theme-material.css';

import { AFFILIATE_ROUTES } from './privateAppRoutes/AffiliateRoutes';
import { CATALOG_ROUTES } from './privateAppRoutes/CatalogRoutes';
import { FBA_INBOUND_ROUTES } from './privateAppRoutes/FbaInboundRoutes';
import { INVOICES_ROUTES } from './privateAppRoutes/InvoicesRoutes';
import { STORAGE_ROUTES } from './privateAppRoutes/storageRoutes';
import { SETTINGS_ROUTES } from './privateAppRoutes/SettingsRoutes';
import { FBA_INBOUND_NEW_ROUTES } from './privateAppRoutes/FbaInboundNew';
import { useSelector } from 'react-redux';
import PoHistoryMobile from '../containers/mobileScreens/PoScreens/PoHistoryMobile';

const AdminUsersContainer = lazy(() => import('../containers/admin/usersContainer'));
const ClientsContainer = lazy(() => import('../containers/ClientsContainer'));
const EmployeesContainer = lazy(() => import('../containers/EmployeesContainer'));
const SourcingContainer = lazy(() => import('../containers/sourcing/SourcingContainer.jsx'));
const CatalogManagementContainer = lazy(() => import('../containers/sourcing/CatalogManagementContainer.jsx'));
const DatabaseContainer = lazy(() => import('../containers/database/DatabaseContainer.jsx'));
const MasterInternalStorageContainer = lazy(() => import('../containers/internal-storage/MasterInternalStorageContainer'));
const CurrentUserInternalStorageContainer = lazy(() => import('../containers/internal-storage/CurrentUserInternalStorageContainer'));
const ProductsContainer = lazy(() => import('../containers/ProductsContainer'));
const ReferalUsers = lazy(() => import('../containers/ReferalUsers'));
const SalesContainer = lazy(() => import('../containers/SalesContainer'));
const VendorsContainer = lazy(() => import('../containers/VendorsContainer'));
const AccountContainer = lazy(() => import('../containers/fbmsetting/index'));
const AccessDenied = lazy(() => import('../components/AccessDenied'));

function RenderIframe(props) {
  const { token } = useSelector((state) => state.auth || {});
  const { route } = props || {};
  const { shipment_id } = useParams();

  return (
    route === 'inbound_shipments' ?
      <iframe is="x-frame-bypass" style={{ height: '100%', width: '100%' }}
        src={`${process.env.API_BASE_URL}/${route}/${shipment_id}?token=${token}`}>
      </iframe> :
      <iframe is="x-frame-bypass" style={{ height: '100%', width: '100%' }}
        src={`${process.env.API_BASE_URL}/${route}?token=${token}`}></iframe>
  );
}

const PRIVATE_APP_ROUTES = [
  {
    path: '/admin/user',
    component: <AdminUsersContainer />,
    group: 'App',
    reducer: 'adminUsers'
  },
  {
    path: '/clients',
    component: <ClientsContainer />,
    group: 'App',
    reducer: [],
    permission: 'clients'
  },
  {
    path: '/employees',
    component: <EmployeesContainer />,
    group: 'App',
    reducer: [],
    permission: 'settings'
  },
  {
    path: '/sourcing',
    component: <CatalogManagementContainer />,
    group: 'App',
    reducer: [],
    permission: 'catalog'
  },
  {
    path: '/sourcing/catalog/:catalogId',
    component: <SourcingContainer />,
    group: 'App',
    reducer: [],
    permission: 'catalog'
  },
  {
    path: '/database',
    component: <DatabaseContainer />,
    group: 'App',
    reducer: [],
    permission: 'catalog'
  },
  {
    path: '/sales',
    component: <SalesContainer />,
    group: 'App',
    reducer: 'sales'
  },
  {
    path: '/vendors',
    component: <VendorsContainer />,
    group: 'App',
    reducer: 'vendors',
    permission: 'purchasing'
  },
  {
    path: '/products',
    component: <ProductsContainer />,
    group: 'App',
    reducer: ['products', 'Products', 'pendingPoIndices']
  },
  {
    path: '/master-internal-storage',
    component: <MasterInternalStorageContainer />,
    group: 'App',
    reducer: 'masterInternalStorage'
  },
  {
    path: '/internal-storage',
    component: <CurrentUserInternalStorageContainer />,
    group: 'App',
    reducer: 'currentUserInternalStorage'
  },
  {
    path: '/referal-users',
    component: <ReferalUsers />,
    group: 'App',
    reducer: 'referals'
  },
  {
    path: '/warehouse-vendors',
    component: <RenderIframe route='warehouse_vendors' />,
    group: 'App',
    reducer: []
  },
  // {
  //   path: '/profile',
  //   component: <RenderIframe route='profile' />,
  //   group: 'App',
  //   reducer: []
  // },
  {
    path: '/account',
    component: <AccountContainer />,
    group: 'App',
    reducer: 'account',
    permission: 'settings'
  },
  // {
  //   path: '/inbound-shipments/:shipment_id',
  //   component: <RenderIframe route='inbound_shipments' />,
  //   group: 'App',
  //   reducer: []
  // },
  {
    path:'/po-mobile',
    component: <PoHistoryMobile />,
    permission: 'purchasing'
  },
  {
    path:'/access-denied',
    component: <AccessDenied />
  }
];

PRIVATE_APP_ROUTES.push(...AFFILIATE_ROUTES, ...CATALOG_ROUTES,
  ...FBA_INBOUND_ROUTES, ...INVOICES_ROUTES,
  ...SETTINGS_ROUTES, ...STORAGE_ROUTES,...FBA_INBOUND_NEW_ROUTES
  );

export { PRIVATE_APP_ROUTES };
